module.exports = __webpack_public_path__ + "img/copy.2659556f.svg";